import { render, staticRenderFns } from "./bullet-points-preview.vue?vue&type=template&id=ad6abd80&scoped=true&"
import script from "./bullet-points-preview.vue?vue&type=script&lang=js&"
export * from "./bullet-points-preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad6abd80",
  null
  
)

export default component.exports